import { render } from "./Notice.vue?vue&type=template&id=783fde9e&ts=true"
import script from "./Notice.vue?vue&type=script&lang=ts"
export * from "./Notice.vue?vue&type=script&lang=ts"

import exportComponent from "/home/francesco/opt/quired/abit/resources/js/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__